// Utility constants and functions for the 16-point WindCompassRose.
// Extracted from WindCompassRose.tsx per RULE-044 (non-component exports in *-utils.ts).

export const DIRECTIONS = [
  'N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE',
  'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW',
] as const;

export type Direction16 = (typeof DIRECTIONS)[number];

/** Full spoken names for ARIA labels. */
export const FULL_NAMES: Record<Direction16, string> = {
  N: 'North',
  NNE: 'North-northeast',
  NE: 'Northeast',
  ENE: 'East-northeast',
  E: 'East',
  ESE: 'East-southeast',
  SE: 'Southeast',
  SSE: 'South-southeast',
  S: 'South',
  SSW: 'South-southwest',
  SW: 'Southwest',
  WSW: 'West-southwest',
  W: 'West',
  WNW: 'West-northwest',
  NW: 'Northwest',
  NNW: 'North-northwest',
};

/** Bearing in degrees for each 16-point direction (0=North, CW). */
export const DIR_DEGREES: Record<Direction16, number> = {
  N:   0,   NNE: 22.5,  NE:  45,  ENE: 67.5,
  E:   90,  ESE: 112.5, SE:  135, SSE: 157.5,
  S:   180, SSW: 202.5, SW:  225, WSW: 247.5,
  W:   270, WNW: 292.5, NW:  315, NNW: 337.5,
};

/**
 * Convert a Direction16 to its compass bearing (0–337.5 in 22.5° steps).
 */
export function directionToBearing(dir: Direction16): number {
  return DIR_DEGREES[dir];
}

/**
 * Round an arbitrary bearing to the nearest 22.5° and return the Direction16.
 */
export function bearingToNearestDirection(bearing: number): Direction16 {
  const normalised = ((bearing % 360) + 360) % 360;
  const index = Math.round(normalised / 22.5) % 16;
  return DIRECTIONS[index];
}
